/* eslint-disable react-hooks/exhaustive-deps */
import { FC, memo, useEffect, useState } from "react";
import { ReactComponent as CalendarIcon } from "assets/icons/calendar-icon.svg";
import RDatePicker from "react-datepicker2";
import { DatePickerProps } from "./DatePicker.props";
import momentJalaali, { Moment } from "jalali-moment";
import { toPersianNum } from "utils/helpers";

import "./style.scss";

const DatePicker: FC<DatePickerProps> = ({
    getSelectedDate,
    className,
    defaultValue,
    name = "kitchen-calendar",
    disabled,
    hasCalendarIcon = true,
    isEmpty,
    reset = false,
    ...props
}) => {
    const [momentDate, setMomentDate] = useState<Moment>();

    useEffect(() => {
        if (reset) {
            setMomentDate(undefined);
        }
    }, [reset]);

    useEffect(() => {
        const now = momentJalaali();
        if (defaultValue) {
            setMomentDate(momentJalaali(defaultValue, "jYYYY-jM-jD"));
        }
        if (!defaultValue && !isEmpty) {
            setMomentDate(
                momentJalaali(
                    now.locale("fa").format("jYYYY/jM/jD"),
                    "jYYYY-jM-jD"
                )
            );
        }
    }, [defaultValue]);

    const handleChange = (date: Moment) => {
        setMomentDate(date);
        const persianDate = {
            day: toPersianNum(date?.locale("fa").format("jDD")),
            weekDay: date?.locale("fa").format("dddd"),
            month: date?.locale("fa").format("jMMMM"),
        };

        getSelectedDate(date?.locale("en").format("YYYY-MM-DD"), persianDate);
    };

    return (
        <div
            className={`kitchen-datepicker-wrap ${className || ""}`}
            data-testid="DatePicker"
        >
            {hasCalendarIcon && <CalendarIcon className="calendar-icon" />}
            <RDatePicker
                persianDigits={false}
                // @ts-ignore
                name={name}
                inputReadOnly
                timePicker={false}
                isGregorian={false}
                value={momentDate}
                onChange={handleChange}
                {...props}
            />
        </div>
    );
};

export default memo(DatePicker);
